import classNames from 'classnames'
import styles from './styles.module.css'
import { LayoutModal, LayoutModalProps } from '@betterplace/design-system/client'

function Modal({
  fullWidth,
  innerClassName,
  className,
  ...props
}: Omit<LayoutModalProps, 'classNames'> & { fullWidth?: boolean; innerClassName?: string; className?: string }) {
  return (
    <LayoutModal
      {...props}
      classNames={{
        modal: classNames(styles.donateFormModal, { [styles.donateFormModalWide!]: fullWidth }, className),
        modalInner: classNames({ [styles.donateFormModalInnerWide!]: fullWidth }),
        titleContainer: styles.donateFormTitle,
        contentContainer: classNames(styles.donateFormModalContent, innerClassName),
      }}
    />
  )
}

export default Modal
